import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cbe65da8")

_pushScopeId("data-v-cbe65da8")
const _hoisted_1 = { class: "form-select" }
const _hoisted_2 = {
  key: 0,
  class: "p-2 cursor-default"
}
const _hoisted_3 = {
  key: 0,
  class: "text-error-detail"
}
const _hoisted_4 = { class: "text-error" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex sm:h-8 md:h-12 lg:h-12 items-center cursor-pointer block w-full select-wrapper shadow-sm left-auto", _ctx.disabled ? 'disable' : ''],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args))),
      style: {
        background: _ctx.background || _ctx.selectOptionColor(),
        cursor: _ctx.disabled ? 'default' : '',
        height: _ctx.height,
      },
      ref: "selectTags"
    }, [
      _createVNode("input", {
        disabled: _ctx.disabled,
        readonly: "",
        class: [_ctx.classes, "cursor-pointer w-full outline-none"],
        style: {
          background: _ctx.background || _ctx.selectOptionColor(),
          cursor: _ctx.disabled ? 'default' : '',
        },
        placeholder: _ctx.placeholder,
        value: _ctx.customValue || _ctx.value
      }, null, 14, ["disabled", "placeholder", "value"]),
      _createVNode("span", {
        class: ["text-2xl cursor-pointer", [
          _ctx.isShowOption ? 'cp-icon-chevron-up' : 'cp-icon-chevron-down',
          _ctx.classes,
        ]]
      }, null, 2)
    ], 6),
    _withDirectives(_createVNode("div", {
      class: "select--option",
      style: { width: _ctx.widthOptionSelect + 'px' }
    }, [
      (_ctx.optionsSelect.length === 0)
        ? (_openBlock(), _createBlock("ul", _hoisted_2, _toDisplayString(_ctx.t('noData')), 1))
        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.optionsSelect, (item, index) => {
            return (_openBlock(), _createBlock("ul", {
              class: [_ctx.indexSelected === index ? 'active' : '', "select--item relative"],
              key: index,
              onClick: ($event: any) => (_ctx.selectOption(item)),
              onMouseover: ($event: any) => (_ctx.hoverOption($event, item)),
              onMouseleave: ($event: any) => (_ctx.hoverLeaveOption(item))
            }, [
              _createTextVNode(_toDisplayString(typeof item === 'object' ? item[_ctx.itemText] : item) + " ", 1),
              _renderSlot(_ctx.$slots, "default", {
                item: item,
                index: index
              }, undefined, true)
            ], 42, ["onClick", "onMouseover", "onMouseleave"]))
          }), 128))
    ], 4), [
      [_vShow, _ctx.isShowOption]
    ]),
    (_ctx.validated && (_ctx.errorsMessage || _ctx.errorServer))
      ? (_openBlock(), _createBlock("span", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", null, _toDisplayString(_ctx.errorsMessage || _ctx.errorServer), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "fixed top-0 left-0 w-screen h-screen z-50",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowOption = false))
    }, null, 512), [
      [_vShow, _ctx.isShowOption]
    ])
  ]))
})